"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setForbidLegoFlag = exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _cookie = require("../utils/cookie");
var _method = _interopRequireDefault(require("../utils/method"));
var _log = _interopRequireDefault(require("../utils/log"));
var _common = require("../utils/common");
var _getZljParams = require("../utils/getZljParams");
var _request = _interopRequireDefault(require("./request"));
var _db = _interopRequireDefault(require("../utils/db"));
var _sendEyeLego = require("../utils/sendEyeLego");
var _validationParameters = require("../utils/validationParameters");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var NOOP = function NOOP() {};
var Methods = new _method.default();
var Lego = /*#__PURE__*/function () {
  function Lego() {
    (0, _classCallCheck2.default)(this, Lego);
    (0, _defineProperty2.default)(this, "db", void 0);
    if (typeof window === 'undefined') {
      return;
    }
    if (window.indexedDB) {
      this.db = (0, _db.default)();
      // this.loopCheck()
    }
  }

  // 字段含义见 http://dashen.zhuanspirit.com/pages/viewpage.action?pageId=4691046
  (0, _createClass2.default)(Lego, [{
    key: "getDefaultParam",
    value: function () {
      var _getDefaultParam = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var cookieid, timestamp, pagetype, appid, ua, version, clienttime, os, osv, clientip, city, apn, resolution, devid, zljCommon;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              cookieid = (0, _cookie.getCookie)('idzz') || (0, _cookie.getCookie)('id58') || (0, _common.getUid)() || (0, _cookie.getCookie)('uuid') || '没有登陆信息';
              timestamp = new Date().getTime();
              pagetype = 'ZHUANZHUANM';
              appid = window['__PAGE_META__'] ? window['__PAGE_META__'].env === 'testing' ? 'zhuanzhuan_test' : 'ZHUANZHUAN' : 'ZHUANZHUAN';
              ua = navigator.userAgent;
              version = (0, _cookie.getCookie)('v') || null;
              clienttime = timestamp;
              os = (0, _cookie.getCookie)('app-os') || Methods.getOS() || '';
              osv = (0, _cookie.getCookie)('app-osv') || Methods.getOsVersion() || '';
              clientip = (0, _cookie.getCookie)('app-clientip') || '';
              city = (0, _cookie.getCookie)('app-city') || '';
              apn = (0, _cookie.getCookie)('app-apn') || '';
              resolution = (0, _cookie.getCookie)('app-resolution') || "".concat(screen.availWidth, "*").concat(screen.availHeight);
              devid = (0, _cookie.getCookie)('tk') || '';
              zljCommon = {};
              if (!(0, _common.isZlj)()) {
                _context.next = 19;
                break;
              }
              _context.next = 18;
              return (0, _getZljParams.getZljCommonParams)();
            case 18:
              zljCommon = _context.sent;
            case 19:
              return _context.abrupt("return", Object.assign({
                cookieid: cookieid,
                timestamp: timestamp,
                pagetype: pagetype,
                appid: appid,
                ua: ua,
                version: version,
                clienttime: clienttime,
                os: os,
                osv: osv,
                resolution: resolution,
                devid: devid,
                clientip: clientip,
                city: city,
                apn: apn
              }, zljCommon));
            case 20:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function getDefaultParam() {
        return _getDefaultParam.apply(this, arguments);
      }
      return getDefaultParam;
    }()
  }, {
    key: "loopCheck",
    value: function loopCheck() {
      var _this = this;
      try {
        // 每10s检查一下是否有发送失败的数据，如果有就重试
        setInterval( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
          var allEvents;
          return _regenerator.default.wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this.db.getData(['failEvents']);
              case 2:
                allEvents = _context5.sent;
                if (allEvents && Array.isArray(allEvents) && allEvents.length > 0) {
                  allEvents.forEach( /*#__PURE__*/function () {
                    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(event) {
                      return _regenerator.default.wrap(function _callee4$(_context4) {
                        while (1) switch (_context4.prev = _context4.next) {
                          case 0:
                            if (!(event.retryNum > 10)) {
                              _context4.next = 5;
                              break;
                            }
                            _context4.next = 3;
                            return _this.db.deleteData(['failEvents'], event.id);
                          case 3:
                            _context4.next = 6;
                            break;
                          case 5:
                            (0, _request.default)(event.data, 2000, true, /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
                              return _regenerator.default.wrap(function _callee2$(_context2) {
                                while (1) switch (_context2.prev = _context2.next) {
                                  case 0:
                                    _context2.next = 2;
                                    return _this.db.deleteData(['failEvents'], event.id);
                                  case 2:
                                    _log.default.info('lego重试发送数据成功');
                                  case 3:
                                  case "end":
                                    return _context2.stop();
                                }
                              }, _callee2);
                            })), /*#__PURE__*/function () {
                              var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(url, data, code, message) {
                                return _regenerator.default.wrap(function _callee3$(_context3) {
                                  while (1) switch (_context3.prev = _context3.next) {
                                    case 0:
                                      _context3.next = 2;
                                      return _this.db.putData('failEvents', _objectSpread(_objectSpread({}, event), {}, {
                                        time: new Date().getTime(),
                                        retryNum: event.retryNum + 1
                                      }));
                                    case 2:
                                      _log.default.info('lego重试发送数据失败', {
                                        url: url,
                                        data: data,
                                        code: code,
                                        message: message
                                      });
                                    case 3:
                                    case "end":
                                      return _context3.stop();
                                  }
                                }, _callee3);
                              }));
                              return function (_x2, _x3, _x4, _x5) {
                                return _ref4.apply(this, arguments);
                              };
                            }(), true, false);
                          case 6:
                          case "end":
                            return _context4.stop();
                        }
                      }, _callee4);
                    }));
                    return function (_x) {
                      return _ref2.apply(this, arguments);
                    };
                  }());
                }
              case 4:
              case "end":
                return _context5.stop();
            }
          }, _callee5);
        })), 10000);
      } catch (error) {}
    }

    // 合并 发送埋点参数
  }, {
    key: "mergeSendArgv",
    value: function () {
      var _mergeSendArgv = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(argv) {
        var defaultParam, param, legoRegSpec, legoRegRegular, legoRegNum;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return this.getDefaultParam();
            case 2:
              defaultParam = _context6.sent;
              param = Object.assign(defaultParam, argv); // 固定类型的埋点场景，pagetype等无需自定义
              if (!param.type) {
                _context6.next = 6;
                break;
              }
              return _context6.abrupt("return", param);
            case 6:
              // 异常情况控制台警告，规则见http://dashen.zhuanspirit.com/pages/viewpage.action?pageId=4691046
              if (!param.pagetype || typeof param.pagetype !== 'string') {
                // 解决 pagetype 为空情况，pagetype 如果为空会导致上报失败
                _log.default.error("\u57CB\u70B9\u8B66\u544A\uFF1Apagetype\u4E0D\u80FD\u4E3A\u7A7A\uFF0C\u5F53\u524Dpagetype=".concat(JSON.stringify(argv.pagetype), "\uFF0C\u6B64\u6B21\u4F1A\u88AB\u66FF\u6362\u4E3A\u9ED8\u8BA4\u7684").concat(defaultParam.pagetype));
                param.pagetype = defaultParam.pagetype;
              }
              if (!param.actiontype) {
                // actiontype如果为空则发出提示
                _log.default.error('埋点错误：actiontype不能为空，该埋点不会被统计到');
              }
              legoRegSpec = /(null)|(undefined)|\s/;
              if (legoRegSpec.test(param.pagetype) || legoRegSpec.test(param.actiontype)) {
                _log.default.error('埋点错误：pagetype和actiontype不可以包含空格，逗号，null，undefined');
              }
              legoRegRegular = /^[a-z_A-Z0-9-\.!@#\$%\\\^&\*\)\(\+=\{\}\[\]\/",'<>~\·`\?:;|]+$/;
              if (!legoRegRegular.test(param.pagetype) || !legoRegRegular.test(param.actiontype)) {
                _log.default.error('埋点错误：pagetype和actiontype只能包含数字、字母和英文符号');
              }
              legoRegNum = /\d{6}/;
              if (legoRegNum.test(param.pagetype) || legoRegNum.test(param.actiontype)) {
                console.error('埋点错误：pagetype和actiontype不可以包含连续6个数字');
              }
              return _context6.abrupt("return", param);
            case 15:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function mergeSendArgv(_x6) {
        return _mergeSendArgv.apply(this, arguments);
      }
      return mergeSendArgv;
    }()
  }, {
    key: "handleParam",
    value: function () {
      var _handleParam = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(param, argv) {
        var token, uid, t, zlj_device_id, endType, defaultBackup, _defaultBackup$pageId, actiontype, zljBack;
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              // 先获取cookie中的tk，然后获取 uid（通过getUid()），最后获取nginx埋的idzz/id58。
              token = (0, _cookie.getCookie)('tk') || (0, _common.getUid)() || (0, _cookie.getCookie)('idzz') || (0, _cookie.getCookie)('id58') || 'token_not_found';
              uid = (0, _common.getUid)() || 'uid_not_found';
              t = (0, _cookie.getCookie)('t') || (0, _cookie.getCookie)('zz_t') || 't_not_found';
              zlj_device_id = (0, _cookie.getCookie)('zlj_device_id') || 'zlj_device_id_not_found';
              endType = 'm';
              defaultBackup = {
                token: token,
                uid: uid,
                t: t,
                zlj_device_id: zlj_device_id,
                endType: endType
              };
              if (typeof window !== 'undefined') {
                defaultBackup = Object.assign(defaultBackup || {});
              }
              // 自定义埋点处理
              if (!(param.type && param.type !== 'Areaexposure' && param.type !== 'METRIC')) {
                _context7.next = 16;
                break;
              }
              if (defaultBackup.pageIdInfo) {
                _context7.next = 10;
                break;
              }
              return _context7.abrupt("return", _log.default.error('埋点错误：pageId 获取异常，请检查配置参数'));
            case 10:
              param.pagetype = param.type;
              actiontype = param.actiontype || ((_defaultBackup$pageId = defaultBackup.pageIdInfo) === null || _defaultBackup$pageId === void 0 ? void 0 : _defaultBackup$pageId.pageId);
              if (actiontype) {
                _context7.next = 14;
                break;
              }
              return _context7.abrupt("return", _log.default.error("\u57CB\u70B9\u9519\u8BEF\uFF1A".concat(param.type, " \u4E2D pageId \u83B7\u53D6\u5F02\u5E38\uFF0C\u8BF7\u68C0\u67E5\u914D\u7F6E\u53C2\u6570")));
            case 14:
              param.actiontype = actiontype;
              defaultBackup = Object.assign(defaultBackup, argv);
            case 16:
              zljBack = {};
              if (!(0, _common.isZlj)()) {
                _context7.next = 21;
                break;
              }
              _context7.next = 20;
              return (0, _getZljParams.getLegoBackUpParams)();
            case 20:
              zljBack = _context7.sent;
            case 21:
              // Logger.info('zljBack', zljBack)
              // 优先级别，最低是默认的，然后是用户设置，最好是用户全局设置的
              param.backup = param.backup ? Object.assign(defaultBackup, zljBack, window['zz_lego_backup'], param.backup) : Object.assign(defaultBackup, zljBack, window['zz_lego_backup']);
              // 过滤掉backup中的一些冗余字段
              if (param.backup.pageIdInfo) {
                delete param.backup.pageIdInfo;
              }
              if (param.pagetype === 'CommodityDetail' || param.pagetype === 'zpmclick' || param.pagetype === 'Areaexposure' || param.pagetype === 'METRIC' || param.type) {
                delete param.backup.pagetype;
              }
              delete param.backup.log;
              delete param.backup.debugger;
              delete param.backup.stayUserTime;
              delete param.backup.forbidLegoInPrerender;
              delete param.backup.forbidLegoInHidden;
              delete param.backup.debuggerCache;
              delete param.backup.autoGoodsExpose;
              delete param.backup.autoAreaExpose;
              return _context7.abrupt("return", param);
            case 33:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      function handleParam(_x7, _x8) {
        return _handleParam.apply(this, arguments);
      }
      return handleParam;
    }()
  }, {
    key: "validationParameters",
    value: function validationParameters(param) {
      // 校验必填参数，如果校验不通过则抛出异常
      (0, _validationParameters.validationRequiredParameters)(param);
      // 校验关键字，如果校验不通过则抛出异常
      (0, _validationParameters.validationKeywordParameters)(param);
    }
  }, {
    key: "send",
    value: function () {
      var _send = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10(argv) {
        var _this2 = this;
        var callback,
          eventCallback,
          mergeParam,
          param,
          _args10 = arguments;
        return _regenerator.default.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              callback = _args10.length > 1 && _args10[1] !== undefined ? _args10[1] : NOOP;
              if (!(isForbidPreRenderUrl() || isForbidLegoInHidden())) {
                _context10.next = 3;
                break;
              }
              return _context10.abrupt("return", _log.default.info('预渲染页面url，lego.send 被禁用'));
            case 3:
              // 包装一下callback，里面添加一个自定义的事件
              eventCallback = function eventCallback(res) {
                var event = new CustomEvent('lego_send', {
                  detail: res
                });
                window.dispatchEvent(event);
                callback(res);
              };
              _context10.next = 6;
              return this.mergeSendArgv(argv);
            case 6:
              mergeParam = _context10.sent;
              _context10.next = 9;
              return this.handleParam(mergeParam, argv);
            case 9:
              param = _context10.sent;
              _context10.prev = 10;
              if (!(typeof window !== 'undefined')) {
                _context10.next = 18;
                break;
              }
              if (!(window['__ZZ_LEGO_ZPMSHOW_LOCK'] && (param.pagetype === 'zpmshow' || param.pagetype === 'CommodityDetail'))) {
                _context10.next = 14;
                break;
              }
              return _context10.abrupt("return");
            case 14:
              if (param.pagetype === 'zpmshow' || param.pagetype === 'CommodityDetail') {
                window['__ZZ_LEGO_ZPMSHOW_LOCK'] = true;
                setTimeout(function () {
                  window['__ZZ_LEGO_ZPMSHOW_LOCK'] = false;
                }, 1500);
              }
              // OcdH5Upgrade 事件，只能每1.5s发送一次
              if (!(window['__ZZ_LEGO_OCD_LOCK'] && param.pagetype === 'OcdH5Upgrade')) {
                _context10.next = 17;
                break;
              }
              return _context10.abrupt("return");
            case 17:
              if (param.pagetype === 'OcdH5Upgrade') {
                window['__ZZ_LEGO_OCD_LOCK'] = true;
                setTimeout(function () {
                  window['__ZZ_LEGO_OCD_LOCK'] = false;
                }, 1500);
              }
            case 18:
              _context10.next = 22;
              break;
            case 20:
              _context10.prev = 20;
              _context10.t0 = _context10["catch"](10);
            case 22:
              // 校验参数，如果不通过则抛出异常
              this.validationParameters(param);
              _log.default.info("lego\u53D1\u9001\u6570\u636Eactiontype: ".concat(param === null || param === void 0 ? void 0 : param.actiontype, " pagetype: ").concat(param === null || param === void 0 ? void 0 : param.pagetype), param);
              (0, _request.default)(param, 2000, true, /*#__PURE__*/function () {
                var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(res) {
                  var _window$__ZZ_LEGO_CON;
                  return _regenerator.default.wrap(function _callee8$(_context8) {
                    while (1) switch (_context8.prev = _context8.next) {
                      case 0:
                        _log.default.info("\u53D1\u9001\u6210\u529Factiontype: ".concat(param === null || param === void 0 ? void 0 : param.actiontype, " pagetype: ").concat(param === null || param === void 0 ? void 0 : param.pagetype));
                        _context8.prev = 1;
                        eventCallback(_objectSpread({
                          status: 'scuess'
                        }, param));
                        if (!(_this2.db && (_window$__ZZ_LEGO_CON = window.__ZZ_LEGO_CONFIG) !== null && _window$__ZZ_LEGO_CON !== void 0 && _window$__ZZ_LEGO_CON.debugger)) {
                          _context8.next = 6;
                          break;
                        }
                        _context8.next = 6;
                        return _this2.db.putData('events', {
                          actiontype: param.actiontype,
                          pagetype: param.pagetype,
                          time: new Date().getTime(),
                          data: param,
                          status: 1,
                          msg: '发送成功',
                          code: '200'
                        });
                      case 6:
                        _context8.next = 11;
                        break;
                      case 8:
                        _context8.prev = 8;
                        _context8.t0 = _context8["catch"](1);
                        _log.default.warn("\u5B58\u50A8\u6210\u529F\u7684\u4E8B\u4EF6\u51FA\u9519".concat(_context8.t0));
                      case 11:
                      case "end":
                        return _context8.stop();
                    }
                  }, _callee8, null, [[1, 8]]);
                }));
                return function (_x10) {
                  return _ref5.apply(this, arguments);
                };
              }(), /*#__PURE__*/function () {
                var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9(url, data, code, message) {
                  var _window$__ZZ_LEGO_CON2;
                  return _regenerator.default.wrap(function _callee9$(_context9) {
                    while (1) switch (_context9.prev = _context9.next) {
                      case 0:
                        _context9.prev = 0;
                        eventCallback(_objectSpread({
                          status: 'fail'
                        }, param));
                        if (!(window && window.indexedDB)) {
                          _context9.next = 6;
                          break;
                        }
                        if (!(_this2.db && (_window$__ZZ_LEGO_CON2 = window.__ZZ_LEGO_CONFIG) !== null && _window$__ZZ_LEGO_CON2 !== void 0 && _window$__ZZ_LEGO_CON2.debugger)) {
                          _context9.next = 6;
                          break;
                        }
                        _context9.next = 6;
                        return _this2.db.putData('events', {
                          actiontype: param.actiontype,
                          pagetype: param.pagetype,
                          time: new Date().getTime(),
                          data: data,
                          status: 0,
                          msg: message,
                          code: code
                        });
                      case 6:
                        _context9.next = 11;
                        break;
                      case 8:
                        _context9.prev = 8;
                        _context9.t0 = _context9["catch"](0);
                        _log.default.warn("\u5B58\u50A8\u5931\u8D25\u7684\u4E8B\u4EF6\u51FA\u9519".concat(_context9.t0));
                      case 11:
                        _log.default.info("\u53D1\u9001\u5931\u8D25actiontype: ".concat(param.actiontype, " pagetype: ").concat(param.pagetype), {
                          url: url,
                          data: data,
                          code: code,
                          message: message
                        });
                      case 12:
                      case "end":
                        return _context9.stop();
                    }
                  }, _callee9, null, [[0, 8]]);
                }));
                return function (_x11, _x12, _x13, _x14) {
                  return _ref6.apply(this, arguments);
                };
              }(), true, false);
              // 以下为可视化埋点方案
              if ((0, _sendEyeLego.isSendEyeLego)()) {
                console.log('sendEyeLego');
                (0, _sendEyeLego.sendEyeLego)(param);
              }
            case 26:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this, [[10, 20]]);
      }));
      function send(_x9) {
        return _send.apply(this, arguments);
      }
      return send;
    }()
  }]);
  return Lego;
}();
var lego = new Lego();
if (typeof window !== 'undefined') {
  window.lego = lego;
}
var _forbidLegoInPrerender, _forbidLegoInHidden;
var setForbidLegoFlag = exports.setForbidLegoFlag = function setForbidLegoFlag(_ref7) {
  var _ref7$forbidLegoInPre = _ref7.forbidLegoInPrerender,
    forbidLegoInPrerender = _ref7$forbidLegoInPre === void 0 ? false : _ref7$forbidLegoInPre,
    _ref7$forbidLegoInHid = _ref7.forbidLegoInHidden,
    forbidLegoInHidden = _ref7$forbidLegoInHid === void 0 ? false : _ref7$forbidLegoInHid;
  _forbidLegoInPrerender = forbidLegoInPrerender;
  _forbidLegoInHidden = forbidLegoInHidden;
};
function isForbidLegoInHidden() {
  return _forbidLegoInHidden && document.hidden == true;
}

// 实时判断 location.search 是否是预渲染页面，预渲染页面则 send 取消
function isForbidPreRenderUrl() {
  return _forbidLegoInPrerender && window.location.href.indexOf('isPreRender=1') > -1;
}
var _default = exports.default = lego;